import React from "react"

export default function Image() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <g clipPath="url(#clip0_171_8009)">
            <path d="M20.0042 19.6199H5.38211C4.45031 19.6199 3.69495 18.8644 3.69495 17.9324V7.80737C3.69495 6.87538 4.45031 6.11987 5.38211 6.11987H20.0042C20.936 6.11987 21.6914 6.87538 21.6914 7.80737V17.9324C21.6914 18.8644 20.936 19.6199 20.0042 19.6199ZM7.63167 8.08862C6.54457 8.08862 5.66331 8.97006 5.66331 10.0574C5.66331 11.1447 6.54457 12.0261 7.63167 12.0261C8.71877 12.0261 9.60003 11.1447 9.60003 10.0574C9.60003 8.97006 8.71877 8.08862 7.63167 8.08862ZM5.9445 17.3699H19.4418V13.4324L16.3658 10.3557C16.201 10.1909 15.934 10.1909 15.7692 10.3557L11.006 15.1199L9.05469 13.1682C8.88998 13.0034 8.62292 13.0034 8.45817 13.1682L5.9445 15.6824V17.3699Z" fill="#B8BAC2" />
         </g>
         <defs>
            <clipPath id="clip0_171_8009">
               <rect width="17.9965" height="18" fill="white" transform="translate(3.69495 3.86987)" />
            </clipPath>
         </defs>
      </svg>
   )
}